// meranie do GA4 - session logika pre onboarding a jednorazove odomknutie
communication.onboardingTrackModule = {
    session: {
        active: null, // aktualny pokus o onboarding alebo jednorazove odomknutie
        timeoutMs: 600000 // 10 minut timeout pre neaktivitu, po ktorej sa pokus ukonci ako "timeout"
    },

    // Interny identifikator eventu pre deduplikaciu v reportoch.
    _createEventId: function () {
        if (window?.crypto?.randomUUID) {
            return window.crypto.randomUUID();
        }
        return "evt_" + Date.now() + "_" + Math.floor(Math.random() * 1000000);
    },

    // Interny identifikator pokusu (onboarding vs one-time login).
    _createAttemptId: function (flowType) {
        var prefix = flowType === "one_time_login" ? "otl" : "onb";
        return prefix + "_" + Date.now() + "_" + Math.floor(Math.random() * 1000000);
    },

    // Mapovanie low-level state na analyticky krok a stav funnelu.
    _getStepMeta: function (state) {
        switch (state) {
            case "idFront":
                return { step_name: "document_front", step_order: 1, step_status: "entered" };
            case "idFrontSuccess":
                return { step_name: "document_front", step_order: 1, step_status: "success" };
            case "idFrontFailed":
                return { step_name: "document_front", step_order: 1, step_status: "failed" };
            case "idBack":
                return { step_name: "document_back", step_order: 2, step_status: "entered" };
            case "idBackSuccess":
                return { step_name: "document_back", step_order: 2, step_status: "success" };
            case "idBackFailed":
                return { step_name: "document_back", step_order: 2, step_status: "failed" };
            case "selfie":
                return { step_name: "selfie", step_order: 3, step_status: "entered" };
            case "selfieSuccess":
                return { step_name: "selfie", step_order: 3, step_status: "success" };
            case "selfieFailed":
                return { step_name: "selfie", step_order: 3, step_status: "failed" };
            default:
                return null;
        }
    },

    // Spolocny payload pre vsetky flow eventy, aby mali konzistentny tvar.
    _baseFlowPayload: function (attempt, data) {
        var payload = {
            event_id: communication.onboardingTrackModule._createEventId(),
            event_timestamp_ms: Date.now(),
            sequence_no: attempt.sequence_no,
            screen_state: data?.state || null,
            next_step: data?.nextStep || null
        };

        if (attempt.flow_type === "one_time_login") {
            payload.one_time_login_attempt_id = attempt.attempt_id;
        } else {
            payload.onboarding_attempt_id = attempt.attempt_id;
        }

        return payload;
    },

    // Rozhodne typ flowu aj pri nekompletnych datach z medzivrstiev.
    _inferFlowType: function (data, activeAttempt) {
        if (data?.info === "OneTimeLogin") return "one_time_login";
        if (activeAttempt?.flow_type) return activeAttempt.flow_type;
        if (data?.info === "isOneTimeLogin") return "one_time_login";
        return "onboarding";
    },

    // Otvori novy pokus a odosle started event.
    _startAttempt: function (flowType, data) {
        var now = Date.now();
        var attempt = {
            attempt_id: communication.onboardingTrackModule._createAttemptId(flowType),
            flow_type: flowType,
            started_at_ms: now,
            last_seen_ms: now,
            sequence_no: 1,
            step_attempts: {
                document_front: 0,
                document_back: 0,
                selfie: 0
            },
            last_step_name: null,
            last_step_status: null,
            last_state: data?.state || null,
            last_info: data?.info || null
        };

        communication.onboardingTrackModule.session.active = attempt;

        var startedEvent = flowType === "one_time_login" ? "one_time_login_started" : "onboarding_started";
        gtag('event', startedEvent, communication.onboardingTrackModule._baseFlowPayload(attempt, data));

        return attempt;
    },

    // Uzatvori pokus a odosle finished event s finalnym statusom.
    _finishAttempt: function (attempt, finishStatus, data) {
        if (!attempt) return;

        var finishedEvent = attempt.flow_type === "one_time_login" ? "one_time_login_finished" : "onboarding_finished";
        var payload = communication.onboardingTrackModule._baseFlowPayload(attempt, data);

        payload.finish_status = finishStatus;
        payload.finish_step = attempt.last_step_name || null;
        payload.total_duration_ms = Date.now() - attempt.started_at_ms;
        payload.failure_reason = data?.errorKey || null;

        gtag('event', finishedEvent, payload);

        communication.onboardingTrackModule.session.active = null;
    },

    onboardingFlow: function (data) {
        try {
            if (!data || !data.state) return false;

            var active = communication.onboardingTrackModule.session.active;
            var now = Date.now();

            // Ak je dlho bez aktivity, uzatvori sa stary pokus timeoutom.
            if (active && (now - active.last_seen_ms) > communication.onboardingTrackModule.session.timeoutMs) {
                communication.onboardingTrackModule._finishAttempt(active, "timeout", {
                    state: "timeout",
                    nextStep: null,
                    info: "timeout",
                    errorKey: "session_timeout",
                    initiator: data.initiator
                });
                active = null;
            }

            var flowType = communication.onboardingTrackModule._inferFlowType(data, active);

            if (data.state === "init") {
                if (active) {
                    communication.onboardingTrackModule._finishAttempt(active, "abandoned", {
                        state: "abandoned",
                        nextStep: null,
                        info: "new_init",
                        errorKey: "new_init",
                        initiator: data.initiator
                    });
                }
                communication.onboardingTrackModule._startAttempt(flowType, data);
                return true;
            }

            if (!active) {
                // Fallback ked nepride init, ale prisli krokove eventy.
                active = communication.onboardingTrackModule._startAttempt(flowType, {
                    state: "init",
                    nextStep: null,
                    info: data?.info || null,
                    errorKey: null,
                    initiator: data?.initiator || null
                });
            }

            active.sequence_no += 1;
            active.last_seen_ms = now;
            active.last_state = data.state;
            active.last_info = data.info || null;

            var stepMeta = communication.onboardingTrackModule._getStepMeta(data.state);
            
            if (stepMeta) {
                if (stepMeta.step_status === "entered") {
                    active.step_attempts[stepMeta.step_name] += 1;
                }

                var currentStepAttemptNo = active.step_attempts[stepMeta.step_name] || 1;
                var stepEvent = active.flow_type === "one_time_login" ? "one_time_login_step" : "onboarding_step";
                var stepPayload = communication.onboardingTrackModule._baseFlowPayload(active, data);

                stepPayload.step_name = stepMeta.step_name;
                stepPayload.step_status = stepMeta.step_status;
                stepPayload.step_order = stepMeta.step_order;
                stepPayload.step_attempt_no = currentStepAttemptNo;
                stepPayload.error_key = data.errorKey || null;

                gtag('event', stepEvent, stepPayload);

                active.last_step_name = stepMeta.step_name;
                active.last_step_status = stepMeta.step_status;
            }

            if (data.state === "canceled") {
                var finishStatus = "canceled";

                // Pri OTL je canceled po selfie success technicke ukoncenie uspesneho flow.
                if (active.last_step_name === "selfie" && active.last_step_status === "success") {
                    finishStatus = "completed";
                }

                communication.onboardingTrackModule._finishAttempt(active, finishStatus, data);
                return true;
            }

            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }
};
